import { ReactElement, ReactNode } from "react";
import Layout from "../Layout";
import { SplittedPageLeft } from "./SplittedPageLeft";
import { SplittedPageRight } from "./SplittedPageRight";

interface SplittedPageProps {
  children: ReactElement<typeof SplittedPageLeft | typeof SplittedPageRight>[];
}

// This component allows to construct the "splitted" page with two columns, the left one being the main content
// and the right one, with a beige background, being the sidebar.
// this layout is used in the PayInvoice and SecurityDeposit pages
export function SplittedPage({ children }: SplittedPageProps) {
  const left: ReactNode[] = [];
  const right: ReactNode[] = [];
  const rest: ReactNode[] = [];

  children.forEach((child) => {
    if (child.type === SplittedPageLeft) {
      left.push(child);
    } else if (child.type === SplittedPageRight) {
      right.push(child);
    } else {
      rest.push(child);
    }
  });

  return (
    <div className="min-h-page bg-white lg:bg-linear-to-r lg:from-white lg:from-50% lg:via-almond-99 lg:via-50% lg:to-almond-99">
      <Layout className="flex mt-0! mb-0! h-full">
        <div className="min-h-page w-full lg:w-2/3 bg-white lg:pr-6 pt-6 pb-80 sm:pb-20 sm:pt-8">
          {left}
        </div>
        <div className="hidden w-1/3 lg:block z-0 pl-6">{right}</div>
      </Layout>
      {rest}
    </div>
  );
}

SplittedPage.Left = SplittedPageLeft;
SplittedPage.Right = SplittedPageRight;
